import {Box, Flex, Image, Text} from '@chakra-ui/react'
import CompletedIcon from '@assets/svgs/progress/completed.svg'
import HappeningIcon from '@assets/svgs/progress/happening.svg'
import UnfinishedIcon from '@assets/svgs/progress/unfinished.svg'
import FlagIcon from '@assets/svgs/flag.svg'
import {useSelector} from 'react-redux'

const Progress = ({
  steps,
  currentIndex,
  currentPercent,
}: {
  steps: any
  currentIndex: number
  currentPercent: number
}) => {
  const {is_finish} = useSelector((state: any) => state.converstation)

  const getIcon = (itemIndex: number) => {
    if (itemIndex < currentIndex) return CompletedIcon
    if (itemIndex === currentIndex) return HappeningIcon
    if (itemIndex > currentIndex) return UnfinishedIcon
  }

  return (
    <Flex w={'100%'}>
      {steps?.map((item: any, index: any) => (
        <Flex key={index} flex={1} alignItems={'center'} pt={'24px'}>
          <Box position={'relative'} flexShrink={0}>
            <Text
              display={{
                base: index === currentIndex ? 'block' : 'none',
                md: 'block',
              }}
              position={'absolute'}
              top={'-24px'}
              left={{base: index === 0 ? 'unset' : '50%', md: '50%'}}
              fontWeight={'600'}
              transform={{
                base: index === 0 ? 'unset' : 'translateX(-50%)',
                md: 'translateX(-50%)',
              }}
              textTransform={'uppercase'}
              fontSize={{base: '10px', md: '12px'}}
              color={index === currentIndex ? '#263238' : '#8C8C8C'}
              style={{
                whiteSpace: 'nowrap',
              }}>
              {item}
            </Text>
            <Image w={{base: '20px', md: '28px'}} src={getIcon(index)} />
          </Box>
          {index < steps.length && (
            <Box
              position={'relative'}
              w={'100%'}
              h={{base: '6px', md: '10px'}}
              bg={'#e7e7e7'}>
              <Box
                position={'absolute'}
                top={0}
                w={`${index < currentIndex || is_finish ? '100%' : `${currentPercent}%`}`}
                h={{base: '6px', md: '10px'}}
                borderRadius={
                  currentPercent < 100 && index === currentIndex
                    ? '0px 6px 6px 0px'
                    : 'unset'
                }
                bg={
                  index <= currentIndex || is_finish
                    ? 'linear-gradient(286deg, #1890FF 25.41%, #18BAFF 94.79%)'
                    : '#e7e7e7'
                }
              />
            </Box>
          )}
        </Flex>
      ))}
      <Flex ml={'8px'} alignItems={'center'}>
        <Image
          w={{base: '20px', md: '24px'}}
          h={{base: '20px', md: '24px'}}
          mt={'12px'}
          src={FlagIcon}
        />
      </Flex>
    </Flex>
  )
}

export default Progress
